<template>
  <section id="profile" role="region" aria-label="Your Profile">
    <h2 class="lead mt-3">Your Profile</h2>
  </section>
</template>
